package fr.manyverse.app.presentation.components.modules.whiteboard

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.model.WhiteboardColor

/**
 * Width of an eraser stroke, in pixels: ten times the default pen width.
 * Also drives the size of the eraser cursor drawn on the canvas.
 */
const val ERASER_STROKE_WIDTH = 40f

/**
 * Drawing tool currently selected by the GM on the whiteboard.
 */
enum class WhiteboardTool {
    PEN,
    ERASER
}

/**
 * The whiteboard background is opaque white: erasing is drawing a thick white stroke.
 * Shared by the canvas preview and the ViewModel so both produce the same stroke.
 */
fun WhiteboardTool.strokeColor(selectedColor: WhiteboardColor): WhiteboardColor = when (this) {
    WhiteboardTool.PEN -> selectedColor
    WhiteboardTool.ERASER -> WhiteboardColor.WHITE
}

fun WhiteboardTool.strokeWidth(selectedWidth: Float): Float = when (this) {
    WhiteboardTool.PEN -> selectedWidth
    WhiteboardTool.ERASER -> ERASER_STROKE_WIDTH
}

/**
 * A stroke left by the eraser. It is rendered by clearing the drawing layer rather than
 * by painting white, so that the grid underneath survives.
 */
val WhiteboardAction.Stroke.isEraser: Boolean
    get() = color == WhiteboardColor.WHITE
